
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { Grid, Button, IconButton, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography, Dialog, DialogActions, DialogContent, FormControl, TextField, FormLabel, InputAdornment, OutlinedInput, CircularProgress, Paper, Chip } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";

import { usePages } from "../../hooks/usePages";

import { table_thead, table_padding } from "../../styles/TableStyle";

import { ActualizarUsuario, AgregarUsuario, Usuarios } from "../../connections/admin/UsuarioConnection";

import { UsuarioProps } from "../../interfaces/admin/UsuarioInterface";

export const UsuariosPage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [openModal, setOpenModal] = useState( false );
    const [showPassword, setShowPassword] = useState(false);

    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idUsuario, setIdUsuario] = useState( 0 );
    const [usuarios, setUsuarios] = useState<UsuarioProps[]>( [] );

    const [nombre, setNombre] = useState( '' );
    const [apellido1, setApellido1] = useState( '' );
    const [apellido2, setApellido2] = useState( '' );
    const [correoElectronico, setCorreoElectronico] = useState( '' );
    const [contrasena, setContrasena] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 5 );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const AplicacionSelected = usuarios.find( ( elem ) => elem.idUsuario === id );

        if( AplicacionSelected ){

            await ActualizarUsuario({ ...AplicacionSelected, activo: checked }).then( resp => {
                
                if( resp.idUsuario ){

                    var newArray = usuarios.map( ( elem ) => {

                    if( elem.idUsuario === id ){
                        elem.activo = checked;
                    }
            
                        return elem;
                    });
            
                    setUsuarios( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el usuario correctamente', variant: 'success' }));   

                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idUsuario !== 0 ){

            const AplicacionSelected = usuarios.find( ( elem ) => elem.idUsuario === idUsuario );

            if( AplicacionSelected ){

                setLoading( true );
    
                await ActualizarUsuario({ ...AplicacionSelected, nombre, apellido1, apellido2, correoElectronico, contrasena, activo: AplicacionSelected.activo }).then( resp => {
                    
                    if( resp.idUsuario ){

                        setTimeout(() => {
                            
                            var newArray = usuarios.map( ( elem ) => {
        
                                if( elem.idUsuario === idUsuario ){
                                    elem.nombre = nombre;
                                    elem.apellido1 = apellido1;
                                    elem.apellido2 = apellido2;
                                    elem.correoElectronico = correoElectronico;
                                    elem.contrasena = contrasena;
                                    elem.activo = AplicacionSelected.activo;
                                }
                        
                                return elem;
                            });
                    
                            setUsuarios( newArray );
                            setOpenModal( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el usuario correctamente', variant: 'success' }));   
                            
                        }, 700);
    
                    }    
        
                });
            }       
    

        }
        else {

            const usuarioAdd: UsuarioProps = {
                idUsuario: 0,
                nombre,               
                apellido1,
                apellido2,
                correoElectronico,
                contrasena,
                activo: true,
            }

            setLoading( true );

            await AgregarUsuario( usuarioAdd ).then( resp => {
                    
                if( resp.idUsuario ){                
            
                    setTimeout(() => {
                        
                        setUsuarios([ ...usuarios, resp ]);
                        setOpenModal( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el usuario correctamente', variant: 'success' }));   

                    }, 700);

                }    
    
            });

        }

    }

    const handleClose = () => {

        setIdUsuario( 0 );
        setNombre( '' );
        setApellido1( '' );
        setApellido2( '' )
        setCorreoElectronico( '' )
        setContrasena( '' );
        setShowPassword( false );

    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setUsuarios( [] );

            await Usuarios().then( resp => {

                setTimeout(() => {
                    
                    setUsuarios( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])   

    return (
        
        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Usuarios' } ]} backgroundPaper={ false }>

            <Grid container spacing={3} >  
                
                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button color="secondary" startIcon={ <UndoIcon /> } sx={{ mt: 1 }} onClick={ () => navigate( '/administracion/' ) }> 
                        Regresar
                    </Button> 

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button                        
                        variant="contained" 
                        sx={{ mt: 1 }} 
                        onClick={ () => {
                            handleClose();
                            setOpenModal( true );
                        }}
                    > 
                        Agregar
                    </Button> 

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...table_thead }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...table_padding, ...table_thead, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...table_padding, ...table_thead, width:'30%' }}> Nombre completo </TableCell>
                            <TableCell style={{ ...table_padding, ...table_thead, width:'40%' }}> Correo electrónico </TableCell>                                      
                            <TableCell style={{ ...table_padding, ...table_thead, width:'15%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ? 
                                    usuarios.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                : 
                                    usuarios
                            )
                            .map( ( { idUsuario, nombre, apellido1, apellido2, correoElectronico, contrasena, activo } ) => (

                                <TableRow key={ idUsuario } >
                                
                                    <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        <Chip                                         
                                            label={ idUsuario }
                                            color={ activo ? 'primary' : 'error' }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        { nombre + ' ' + apellido1 + ' ' + apellido2 }
                                    </TableCell>    

                                    <TableCell>
                                        { correoElectronico }
                                    </TableCell>                                          
                                                  
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idUsuario ) }
                                        />
                                            
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdUsuario( idUsuario );
                                                    setNombre( nombre );
                                                    setApellido1( apellido1 );
                                                    setApellido2( apellido2 )
                                                    setCorreoElectronico( correoElectronico )
                                                    setContrasena( contrasena );

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  

                                    </TableCell>

                                </TableRow>

                            ))
                        }                    

                        { 
                            ( usuarios.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 53 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }
                        
                    </TableBody>

                    <TableFooter>

                        {
                            usuarios.length !== 0
                            &&

                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> 
                                            Total de registros: { usuarios.length } 
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ usuarios.length }                                        
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>

                            }

                    </TableFooter>
                    
                </Table>

            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
            
                <DialogContent>      

                    <Grid container spacing={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>
                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Nombre(s)</FormLabel>
                                <TextField
                                    placeholder="Juan"
                                    autoComplete="off"                             
                                    variant="outlined"     
                                    value={ nombre }           
                                    onChange={ (e) => setNombre( e.target.value ) }
                                />
                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>
                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Apellido 1</FormLabel>
                                <TextField
                                    placeholder="Perez"
                                    autoComplete="off"                             
                                    variant="outlined"        
                                    value={ apellido1 }           
                                    onChange={ (e) => setApellido1( e.target.value ) }          
                                />
                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} fullWidth>
                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Apellido 2</FormLabel>
                                <TextField
                                    placeholder="Perez"
                                    autoComplete="off"                             
                                    variant="outlined"     
                                    value={ apellido2 }           
                                    onChange={ (e) => setApellido2( e.target.value ) }          
                                />
                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>
                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Correo electrónico</FormLabel>
                                <TextField
                                    type="email"
                                    placeholder="persona@pjecz.gob.mx"
                                    autoComplete="off"                             
                                    variant="outlined"       
                                    value={ correoElectronico }           
                                    onChange={ (e) => setCorreoElectronico( e.target.value ) }      
                                />
                            </FormControl>

                        </Grid>
                        
                        {
                            idUsuario !== 0
                            &&
                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl sx={{ mt: 2 }} required fullWidth>
                                        <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1 }}>Contraseña</FormLabel>
                                        <OutlinedInput
                                            placeholder="****************"                                
                                            autoComplete="current-password"  
                                            type={ showPassword ? 'text' : 'password' }
                                            value={ contrasena }           
                                            onChange={ (e) => setContrasena( e.target.value ) }
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        edge="end"
                                                        size='small'
                                                        aria-label={ showPassword ? 'hide the password' : 'display the password' }                                        
                                                        onClick={ () => setShowPassword( ( show ) => !show ) }
                                                    >
                                                        { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon /> }
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>

                                </Grid>
                        }                        
                        
                    </Grid>     

                </DialogContent>

                <DialogActions>

                    <Button 
                        color='secondary'
                        disabled={ loading } 
                        onClick={ () => { setOpenModal( false ); handleClose(); } }
                    > 
                        Cancelar 
                    </Button>

                    <Button 
                        loading={ loading } 
                        disabled={ 
                            idUsuario !== 0
                            ?
                                nombre === '' || apellido1 === '' || correoElectronico === '' || contrasena === '' 
                            : 
                                nombre === '' || apellido1 === '' || correoElectronico === ''
                        } 
                        variant='contained' 
                        onClick={ handleGuardar }
                    > 
                        Guardar 
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
        
    )
}